<template>
  <div class="enroll_show" v-if="clazz">
    <van-nav-bar
      title="确认订单1"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="header bgwhite">
      <div class="title">{{ clazz.clazz_name }}</div>
    </div>

    <div class="cycle_range bgwhite">
      <div class="left">
        <span class="weight">{{ clazz.start_time_format1 }}</span>
        至
        <span class="weight">{{ clazz.end_time_format1 }}</span>
      </div>
      <div class="right">一共{{ clazz.day_num }}天</div>
    </div>

    <!-- :title="'报名 ¥'+contractFee" -->
    <bottom-btn
      class="bgwhite"
      :title="'报名'"
      :fixed="false"
      @click.native="gotoEnroll"
    />
  </div>
</template>

<script>
import { Icon, Toast, NavBar } from 'vant'
import BottomBtn from '@/components/BottomBtn'
import { clazzSimpleInfo, enrollClazz } from '@/api/clazz'

export default {
  name: 'EnrollShow',
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    BottomBtn
  },
  data () {
    return {
      startDate: '',
      clazz: null,
      monList: []
    }
  },
  computed: {
    contractFee () {
      return parseFloat(this.clazz.contract_fee)
    }
  },
  filters: {
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
    },
    async gotoEnroll () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      let response = await enrollClazz(this.clazz.uuid)
      Toast.clear()

      if (response.data.is_free) {
        this.$router.push('/')
      } else {
        this.$router.push('/order/' + response.data.order_id + '/confirm')
      }
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.enroll_show {
  background-color: #f8f8f8;
  .header {
    height: 100px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .cycle_range {
    font-size: 26px;
    color: #969696;
    background-color: #fcfcfc;
    padding: 30px 30px;
    display: flex;
    justify-content: space-between;
    .weight {
      color: #323233;
      font-size: 34px;
      // font-weight: bold;
    }
  }
}
</style>
